// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetProductCallRulesQuery,
    BaseResponseProductCallRulesFoundResponse,
    PostProductCallRulesBody,
} from '../types';

/**
 * findById
 *
 * @export
 * @tags product-call-rules-controller
 * @link [GET] /productCallRules
 */
export function getProductCallRules(
    options: ApiOptions<never, GetProductCallRulesQuery> & { params: GetProductCallRulesQuery }
): Promise<BaseResponseProductCallRulesFoundResponse> {
    return request<never, never, GetProductCallRulesQuery>('/productCallRules', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getProductCallRules',
    });
}

/**
 * save
 *
 * @export
 * @tags product-call-rules-controller
 * @link [POST] /productCallRules
 */
export function postProductCallRules(
    data: PostProductCallRulesBody
): Promise<BaseResponseProductCallRulesFoundResponse>;
export function postProductCallRules(
    data: PostProductCallRulesBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseProductCallRulesFoundResponse>;
export function postProductCallRules(
    data: PostProductCallRulesBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseProductCallRulesFoundResponse> {
    return request<PostProductCallRulesBody, never, never>('/productCallRules', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postProductCallRules',
    });
}

export const meta = [
    { tags: ['product-call-rules-controller'], path: '/productCallRules', method: 'get' },
    { tags: ['product-call-rules-controller'], path: '/productCallRules', method: 'post' },
];
